import { useScrollTop } from '@/modules/Core/composables'
import useSearchStore from '@/modules/Search/store'

function useSetItinerarySummary() {
  const searchStore = useSearchStore()
  const scrollTop = useScrollTop()

  function handle() {
    searchStore.setIsItinerarySelected(true)
    scrollTop()
  }

  return {
    handle,
  }
}

export default useSetItinerarySummary
